const EN = {
    report: 'Report | Reports',
    recipient: 'Recipient | Recipients',
    schedule: 'Schedule | Schedules',
    generate_report: 'Generate Reports',
    report_schedules: 'Schedule Reports',
    reset: 'Reset',
    change_report: 'Change Report',
    change_report_warning: 'Do you really want to choose another report? All unsaved changes in the current one will be lost.',
    warning: 'Warning!',
    something_went_wrong: 'Looks like something went wrong. Please contact your service manager for assistance.',
    unexpected: 'If this is unexpected, please contact your service manager for assistance.',
    create_schedule: 'Create Schedule',
    create_schedule_short: 'Schedule',
    select_report_first: 'Select the report first',
    save_as_own_report: 'Save',
    show_more: 'Show more',
    plase_wait: 'Please wait...',
    gathering: 'Gathering data...',
    combining: 'Combining data...',
    structuring: 'Structuring data...',
    organising: 'Organising data...',
    collecting: 'Collecting data...',
    displaying: 'Displaying data...',
    historical_data: 'Historical data for',
    filters: 'Filters',
    csv_export: 'Export to CSV',
    re_run: 'RE-RUN',
    no_data: 'There is no data',
    change_filter_for_more_results: 'Try to change filters criteria to get more results',
    add_new_report: 'Add new Report',
    edit_report: 'Edit Report',
    create_report: 'Create Report',
    edit: 'Edit',
    export: 'Export',
    report_name: 'Report name',
    save_report_in: 'Save report in',
    select: 'Select',
    edit_schedule: 'Edit Schedule',
    title: 'Title',
    trigger_date: 'Trigger date',
    repeats: 'Repeats',
    frequency: 'Frequency',
    repeating_ends: 'Repeating ends',
    after: 'After',
    occurences: 'occurences',
    on_date: 'On date',
    submit: 'Submit',
    add_new: 'Add new',
    add: 'Add',
    search_add_recipient: 'Search or add a recipient',
    add_recipient: 'Add a recipient',
    can_view: 'can view',
    can_edit: 'can edit',
    remove_report: 'Remove report',
    enter_report_name_to_confirm_removal: 'Enter the report name to confirm removal',
    caution_removing_report: 'CAUTION! ALL SCHEDULES ASSIGNED TO THIS REPORT WILL BE REMOVED!',
    remove: 'Remove',
    remove_schedule: 'Remove schedule',
    enter_schedule_name_to_confirm_removal: 'Enter the schedule name to confirm removal',
    caution_removing_schedule: `CAUTION! THIS ACTION CAN'T BE REVERSED!`,
    select_path: 'Select path',
    error_occured: 'Error occured',
    select_report: 'Select Report',
    name: 'Name',
    last_run: 'Last Run',
    chart: 'Chart',
    charts: 'Charts',
    ticket_history: 'Ticket History',
    general_info: 'General Info',
    map: 'Map',
    add_path: 'Add path',
    add_filter: 'Add filter',
    add_another_filter: 'Add another filter',
    delete_path: 'Delete path',
    delete_filter: 'Delete filter',
    from_number: 'From (number)',
    to_number: 'To (number)',
    enter_text: 'Enter text',
    date: 'Date',
    date_label: 'Date | Dates',
    date_range: 'Date range',
    number: 'Number',
    day: 'Day | Days',
    run: 'Run',
    apply: 'Apply',
    group_by: 'Group by',
    stack_by: 'Stack by',
    columns: 'Columns',
    order_by: 'Order by',
    report_type: 'Report Type',
    report_subtype: 'Report Subtype',
    empty_here: `It's empty here`,
    no_reports_for_this_type: 'There is no reports for this report type',
    select_report_type: 'Select report type',
    choose_one_from_reports: 'Choose one from the list on the left',
    outline: 'Outline',
    filters: 'Filters',
    addons: 'Addons',
    device_search: 'Device Search',
    shared_reports: 'Shared Reports',
    create_shared: 'Share Report',
    create_shared_short: 'Share',
    edit_shared: 'Edit shared report',
    remove_shared: 'Remove shared report',
    are_you_sure_remove: 'Are You sure You want to delete',
    shared_report_exists: 'This shared report name already exists',
    tooltip_report_type: 'Select Report Type to choose the data source',
    tooltip_report_name: 'Select Report Name to choose which report You want to generate',
    tooltip_group_by: 'Select this option to create reports with distinct group per selected column. Same values will be linked to appropriate group',
    tooltip_stack_by: 'Select this option to create stacked reports with distinct groups per selected column. Same values will be stacked as one block of the bar',
    tooltip_chart_rerun: 'You need to rerun the report to see the effect of choosing this chart.',
    additional_dates_grouping: 'Additional Dates Grouping',
    tooltip_additional_dates_grouping: 'Select this option to add additional date column group for each group created with "Group By" field. You can select "Year", "Month" and "Day" to change grouping time interval',
    aggregate: 'Aggregate',
    tooltip_aggregate: 'Select this option to create additional column with "Average", "Mininum", "Maximum", "Total" value of selected column for each group created with "Group By" field',
    tooltip_columns: 'Select all columns that You want in your report. Selection order will remain on report columns order. You can leave this field empty to add all possible columns.',
    tooltip_order: 'Choose by which column data should be sorted. You can select multiple columns and set ascending and descending directions for each column',
    tooltip_datefilter: 'Select Date type and add column with "Datetime" data type using "Add filter" button. If you want to apply date to that filter, you have to select "true" from selectbox of selected property. You can also select other data types columns and set proper value for filtering.',
    tooltip_chart: 'Select one of the charts to display it above Your report. After saving report, you can add this chart to Your Dashboard panel',
    tooltip_map: 'Set this value to "Show" so You can view last locations based on "latitude" and "longitude" columns',
    tooltip_recipients_emails: 'Select all recipients that you want to share with selected report. You can type in any e-mail adres and send report to users that dont have active TRG ServiceHub Account',
    tooltip_recipients: 'Select all recipients that you want to share with selected report. You can choose only users with active TRG ServiceHub Account',
    tooltip_myown_report: 'Please choose report that You want to share. It will appear on shared user Reports Type "My Company reports". You can choose only reports from "My own reports" Report Type.',
    tooltip_unique_title: 'Please type in unique title name for new shared report',
    tooltip_title: 'Please type in title name for new schedule',
    tooltip_report: 'Please select report that You want to schedule. You can choose any report',
    tooltip_trigger_date: 'Please select schedule trigger date',
    tooltip_repeats: 'If report generation needs to be repeated, please click this checkbox',
    tooltip_frequency: 'Select how often report generation should be repeated',
    tooltip_repeating_ends: 'Please select when we need to stop scheduling this report',
    my_reports: 'My Reports',
    my_own_report: 'Saved Reports',
    my_company_report: 'Shared with Me',
    foreground_duration: 'App in Foreground [Time]',
    asset_number: 'Asset Number',
    battery: 'Battery Level [%]',
    charging: 'Charging Status',
    battery_usage: 'Battery Health',
    battery_status: 'Battery Status',
    battery_temperature: 'Battery Temperature',
    battery_time_left: 'Battery Time Left',
    batterySerialNumber: 'Battery Serial No.',
    gsm_cell_tower_id: 'Cell Tower ID',
    gsm_name: 'Network Provider',
    gsm_signal: 'Mobile Signal Strength',
    gsm_type: 'Mobile [3G,4G,5G]',
    gsm_download: 'Data Download [Mobile] [KB]',
    has_battery_changed: 'Battery: In Day Change',
    has_screen_time: 'Screen Time: In Day Change',
    max_screen_time: 'Max. Screen Time',
    max_screen_time_str: 'Max. Screen Time',
    wifi_download: 'Data Download [Wi-Fi] [KB]',
    gsm_upload: 'Data Upload [Mobile][KB]',
    wifi_upload: 'Data Upload [Wi-Fi] [KB]',
    build_no: 'Device Build No.',
    device_ip: 'Device IP',
    manufacturer: 'Device Manufacturer',
    model: 'Device Model',
    latitude: 'Location - Lat',
    longitude: 'Location - Long',
    os_version: 'Android Version',
    screen_time: 'Screen Time Usage',
    security_patch_date: 'Android Patch Date',
    total_external_storage: 'Total External Storage',
    external_storage: 'Free External Storage',
    total_internal_storage: 'Total Internal Storage',
    internal_storage: 'Free Internal Storage',
    total_ram: 'Installed Ram',
    ram: 'Free RAM',
    wifi_name: 'Wi-Fi Name',
    wifi_signal: 'Wi-Fi Signal Strength',
    client_id: 'Client ID',
    package_name: 'Application',
    path: 'Path',
    version_name: 'App Version',
    updated_at: 'Updated At',
    created_at: 'Created At',
    bssid: 'BSSID',
    android_id: 'Android ID',
    start_date: 'Start Date',
    end_date: 'End Date',
    imei: 'IMEI',
    serial_number: 'Serial Number',
    map_hidden: 'Map element has been hidden due to lack of location data',
    truncated_output: 'You received all available number of records',
    custom_1: 'Network Name',
    custom_2: 'Network ID',

    asset_number__c: 'Asset Number',
    custom_attribute__c: 'Custom Attribute',
    customer_reference__c: 'Customer Reference',
    record_type_name__c: 'Record Type',
    reported_fault_category__c: 'Reported Fault Category',
    reported_fault__c: 'Reported Fault',
    accessories__c: 'Accessories',
    contact_fao__c: 'Contact Fao',
    organisation_name__c: 'Organisation Name',
    address_line_1__c: 'Address',
    address_line_2__c: 'Address',
    address_line_3__c: 'Address',
    address_line_4__c: 'Address',
    country__c: 'Country',
    postcode__c: 'Postcode',
    sitename__r: 'Site',
    shipment_notification_email_address__c: 'Shipment E-mail',
    shipment_notification_mobile_number__c: 'Shimpent Mobile Number',
    subject: 'Subject',
    description: 'Description',
    cost_centre_number__c: 'Cost Centre Number',
    user__c: 'User',
    user_id__c: 'User ID',
    user_role__c: 'User Role',
    reported_fault_category_2__c: 'Reported Fault Category 2',
    reported_fault_2__c: 'Reported Fault 2',
    reported_fault_category_3__c: 'Reported Fault Category 3',
    reported_fault_3__c: 'Reported Fault 3',
    build_type__c: 'Build Type',
    needed_date__c: 'Needed Date',
    caller_name__c: 'Caller Name',
    callers_phone_number__c: "Caller's Phone Number",
    primary_contact_email_address__c: 'Primary Contact E-mail Address',
    secondary_contact_email_address__c: 'Secondary Contact E-mail Address',
    approved_by__c: 'Approved By',
    lost_or_stolen_approved__c: 'Lost or Stolen Approved',
    approved_date__c: 'Approved Date',
    preferred_collection_date__c: 'Preferred Collection Date',
    affected_sim_number__c: 'Affected SIM Number',
    sim__c: 'SIM',
    ngb_sim_type__c: 'NGB SIM Type',
    sim_card__c: 'SIM Card',
    crime_reference_number__c: 'Crime Reference Number',
    courier__c: 'Courier',
    outbound_tracking__c: 'Outbound Tracking',
    createddate: 'Created Date',
    lastmodifieddate: 'Last Modified Date',
    dispatched_date_time__c: 'Dispatched Date Time',
    expected_dispatch_date__c: 'Expected Dispatch Date',
    signed_for_by__c: 'Signed For By',
    dispatch_delay_s__c: 'Dispatch Delay S',
    reason_for_delay__c: 'Reason For Delay',
    faults_found__c: 'Faults Found',
    resolution__c: 'Resolution',
    closeddate: 'Closed Date',

    ticket_hash: 'Ticket #',
    status: 'Status',
    type: 'Type',
    site: 'Site',
    created_by: 'Created By',
    date_created: 'Date Created',
    date_closed: 'Date Closed',
    view_ticket: 'View Ticket',
}
  
export default EN